import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-statement-details',
  templateUrl: './statement-details.component.html',
  styleUrls: ['./statement-details.component.scss'],
  standalone: false
})
export class StatementDetailsComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  statementDetailsTitle = 'Statement Details';
  statementDetailsHeader = 'This feature is currently being developed.';
  ngOnInit(): void {}
  handleClick() {
    this.router.navigate(['/benefits/billing-statements/billing-statements-list'], { relativeTo: this.route });
  }
}
